"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedViewsApi = void 0;
var urls_1 = require("../../urls");
function getCsrfToken() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.startsWith("csrftoken=")) {
            return decodeURIComponent(cookie.substring("csrftoken=".length));
        }
    }
    return "";
}
var SavedViewsApi = (function () {
    function SavedViewsApi(projectId) {
        this.projectId = projectId;
    }
    SavedViewsApi.prototype.fetchViews = function (listType) {
        var url = (0, urls_1.resolve)(urls_1.Urls.saved_views, this.projectId) + "?list_type=" + listType;
        return fetch(url, { credentials: "same-origin" })
            .then(function (res) { return res.json(); })
            .then(function (data) { return ({
            views: data.views.map(function (v) { return ({
                id: v.id,
                name: v.name,
                queryString: v.url,
                isShared: v.isShared,
                isModified: v.isModified,
            }); }),
            isAdmin: data.isAdmin || false,
        }); });
    };
    SavedViewsApi.prototype.createView = function (name, listType, url, shared) {
        return fetch((0, urls_1.resolve)(urls_1.Urls.saved_views, this.projectId), {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": getCsrfToken(),
            },
            body: JSON.stringify({ name: name, list_type: listType, url: url, shared: shared }),
        })
            .then(function (res) { return res.json(); })
            .then(function (v) { return ({
            id: v.id,
            name: v.name,
            queryString: v.url,
            isShared: v.isShared,
            isModified: v.isModified,
        }); });
    };
    SavedViewsApi.prototype.updateView = function (viewId, data) {
        return fetch((0, urls_1.resolve)(urls_1.Urls.saved_view_detail, this.projectId, viewId), {
            method: "PUT",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": getCsrfToken(),
            },
            body: JSON.stringify(data),
        })
            .then(function (res) { return res.json(); })
            .then(function (v) { return ({
            id: v.id,
            name: v.name,
            queryString: v.url,
            isShared: v.isShared,
            isModified: v.isModified,
        }); });
    };
    SavedViewsApi.prototype.deleteView = function (viewId) {
        return fetch((0, urls_1.resolve)(urls_1.Urls.saved_view_detail, this.projectId, viewId), {
            method: "DELETE",
            credentials: "same-origin",
            headers: {
                "X-CSRFToken": getCsrfToken(),
            },
        }).then(function () { return undefined; });
    };
    return SavedViewsApi;
}());
exports.SavedViewsApi = SavedViewsApi;
